module.exports = __webpack_public_path__ + "static/media/NewDesignHrExp.c8195386.svg";